/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { getTranslation, getIsTemplatesUSer } from '@/store/getters'
import { toggleToaster, editMagazine } from '@/store/actions'

import styles from './styles.scss'

/** Components */
import Checkbox from '@/components/Checkbox'

class MagazineEdit extends Component {
  state = {
    title: '',
    description: '',
    is_draft: '',
    template_premium: ''
  }

  componentWillMount() {
    const { magazine } = this.props

    if (!magazine) {
      return this.props.history.push('/dashboard')
    }

    this.setState({
      title: magazine.title,
      description: magazine.description,
      is_draft: !!+magazine.is_draft,
      template_premium: !!+magazine.template_premium
    })
  }

  handleEditMagazine = () => {
    const { translation, magazine, editMagazine, toggleToaster, handleClose } = this.props

    editMagazine(magazine.id, this.state)
    handleClose()
    toggleToaster({
      isVisible: true,
      message: translation('general-magazine-edit-success'),
      position: 'top-right',
      type: 'success'
    })
  }

  render() {
    const { title, description, is_draft, template_premium } = this.state
    const { show, translation, templateCreator, handleClose } = this.props

    return (
      <section className={'ba-flex ba-jc-center ba-ai-center ' + (show ? styles['ba-modal'] : styles['ba-none'])}>
        <div className={'ba-card ' + styles['ba-modal-card']}>
          <div className="ba-top ba-flex ba-jc-sb">
            <span className="ba-title ba-montserrat-700">
              {translation('general-edit-information')}
            </span>

            <button className='ba-btn ba-btn-close ba-sm ba-rounded'
              onClick={handleClose}>
              <builderall-icon code='64f7' />
            </button>
          </div>

          <div className="ba-content ba-w-100">

            <div className='ba-box-input ba-mg-t-1'>
              <div className='ba-info'>
                <div className='ba-info-left'>
                  <label className='ba-label' for='title'>
                    {translation('general-title')}
                  </label>
                </div>
              </div>
              <input type='text' id='title' className='ba-input' maxLength="50"
                placeholder={translation('magazine-edit-title-empty')}
                value={title}
                onChange={({ target }) => this.setState({ title: target.value })} />
            </div>

            <div className='ba-box-input ba-mg-t-1'>
              <div className='ba-info'>
                <div className='ba-info-left'>
                  <label className='ba-label' for='description'>
                    {translation('general-description')}
                  </label>
                </div>
              </div>
              <input type='text' id='description' className='ba-input' maxLength="50"
                placeholder={translation('magazine-create-label-description')}
                value={description}
                onChange={({ target }) => this.setState({ description: target.value })} />

              {
                templateCreator &&
                <React.Fragment>
                  <Checkbox
                    label={translation('dashboard-publish-checkbox')}
                    checked={!is_draft}
                    onChange={value => this.setState({ is_draft: !value })}
                  />
                  <Checkbox
                    label={translation('dashboard-premium-checkbox')}
                    checked={template_premium}
                    onChange={value => this.setState({ template_premium: value })}
                  />
                </React.Fragment>
              }
            </div>

            <div className='ba-flex ba-jc-fe ba-mg-t-3'>
              <button className='ba-btn ba-md ba-blue'
                disabled={!this.state.title}
                onClick={this.handleEditMagazine}>
                <builderall-icon code='2780' />
                {translation('general-save')}
              </button>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  const templateCreator = getIsTemplatesUSer(state)
  return { translation, templateCreator }
}
export default withRouter(connect(
  mapStateToProps, {
  toggleToaster,
  editMagazine
}
)(MagazineEdit))



// WEBPACK FOOTER //
// ./src/pages/Dashboard/components/MagazineEdit/index.js